import { DownTimeTrackingStatusEnum } from "@gtpl/shared-models/common-models";

export class DownTimeFiltersDto  {
    downtimeReasonId : number;
    status:DownTimeTrackingStatusEnum;
}